import { unableToGetFacebookUserData } from "./facebookSignupErrors";
import { facebookAccountStatus } from "./constants";

function onFacebookScripLoaded(onload) {
  window.fbAsyncInit = () => {
    FB.init({
      appId: this.identityProviders.facebook.appId,
      cookie: true, // Enable cookies to allow the server to access the session. // TODO Check if this is needed
      xfbml: true, // Parse social plugins on this webpage. // TODO Check if this is needed
      version: this.identityProviders.facebook.apiVersion
    });
  };
  onload();
}

function performFacebookLogin(config, resolve, reject, connectedCallback) {
  FB.login(
    response => {
      if (response.status === facebookAccountStatus.CONNECTED) {
        connectedCallback(response, config, resolve, reject).call(this);
      } else {
        reject(unableToGetFacebookUserData);
      }
    },
    { scope: this.identityProviders.facebook.permissions }
  );
}

export function loadFacebookSdk(src, onload = () => {}) {
  if (typeof FB === "undefined") {
    const script = document.createElement("script");
    script.setAttribute("src", src);
    script.addEventListener("load", onFacebookScripLoaded.bind(this, onload));
    document.body.appendChild(script);
  } else {
    onload();
  }
}

export function performFacebookIdentification(config, resolve, reject, connectedCallback) {
  const onLoginStatusReceived = response => {
    switch (response.status) {
      case facebookAccountStatus.CONNECTED:
        connectedCallback(response, config, resolve, reject).call(this);
        break;
      case facebookAccountStatus.NOT_AUTHORIZED:
      case facebookAccountStatus.UNKNWON:
        performFacebookLogin.call(this, config, resolve, reject, connectedCallback);
        break;
      default:
        reject(unableToGetFacebookUserData);
    }
  };
  FB.getLoginStatus(onLoginStatusReceived);
}
